import React from 'react';
import { Anchor, Flex, Heading, IconFaceUnhappy, Paragraph } from '@zillow/constellation';
import { useWizard, WizardSubStep } from '@zillow/zrs-rental-applications';
import { CUSTOMER_SUPPORT_LINK } from '../../../constants/urls';
import { ExitReason } from '../../../../../models';
import { useIdVerificationCallbacks } from '../../../contexts/IdVerificationContext';

interface GenericErrorProps {
  id: string;
}

export default function GenericError({ id }: GenericErrorProps) {
  const { currentSubStep } = useWizard();
  const { onExit } = useIdVerificationCallbacks();

  return (
    <WizardSubStep
      id={id}
      hidden={currentSubStep !== id}
      meta={{
        renderNextButton: 'Done',
        renderBackButton: () => null,
      }}
      onRequestNext={(abortController: AbortController) => {
        abortController.abort();
        onExit({ reason: ExitReason.GenericError, success: false });
      }}
      render={() => (
        <Flex display="flex" flexDirection="column" gap="sm">
          <IconFaceUnhappy size="md" fontColor="blue600" />
          <Heading level={4} as="h2">
            Something went wrong!
          </Heading>
          <Paragraph>
            We are unable to process your request to verify your identity at this time. Contact{' '}
            <Anchor href={CUSTOMER_SUPPORT_LINK} target="_blank" rel="noopener noreferrer">
              customer support
            </Anchor>{' '}
            for help.
          </Paragraph>
        </Flex>
      )}
    />
  );
}
